import * as React from 'react';
import { Tabs, Icon, Spin } from 'antd';
import { ExpenseEntryReport } from './ExpenseEntryReport';
import { CompanyService } from '../../service/CompanyService';
import { AddExpenseEntry } from './AddExpenseEntry';
import { CompanyNodeEdge, Bussiness } from '../master/Company/constants';
import { UserService } from '../../service/UserService';
import { UserNodeEdge } from '../../components/user/constants';
import { checkAddPermission } from '../helper';
import { ExpenseEntryReportDateRange } from './ExpenseEntryReportDateRange';

export class ExpenseEntry extends React.Component<{}, State> {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '1',
      afterExpenseEntry: '',
      currentPageExpenseEntry: 1,
      company: null,
      business: null,
      user: null,
      branchId: '',
      companyId: '',
    };
  }

  companyService = new CompanyService();
  userService = new UserService();

  componentDidMount() {
    this.companyService?.company$.subscribe((company) =>
      this.setState({ company }),
    );
    this.companyService?.selectedBussiness$.subscribe((business) => {
      if (business) {
        const companyId =
          business.type === 'company' ? business.id : business.companyId;
        const branchId = business.type === 'branch' ? business.id : null;
        companyId && this.setState({ companyId, branchId, business });
      }
    });
    this.userService?.user$.subscribe((user) =>
      this.setState({ user: user?.user }),
    );
  }

  handleTabChange = (activeKey: string) => {
    if (activeKey === '1') {
      this.setState({ activeKey });
      return;
    }
    this.setState({ activeKey });
  };

  afterStackExpenseEntry = [''];

  onPageChangeExpenseEntry = (
    next: boolean,
    afterExpenseEntry: string | null | undefined,
    nextPage: boolean,
  ) => {
    if (next && nextPage) {
      this.setState({
        afterExpenseEntry: afterExpenseEntry || '',
        currentPageExpenseEntry: this.state.currentPageExpenseEntry + 1,
      });
      this.afterStackExpenseEntry.push(afterExpenseEntry || '');
    } else if (!next && this.afterStackExpenseEntry.length > 1) {
      this.afterStackExpenseEntry.pop();
      this.setState({
        afterExpenseEntry:
          this.afterStackExpenseEntry[this.afterStackExpenseEntry.length - 1],
        currentPageExpenseEntry: this.state.currentPageExpenseEntry - 1,
      });
    }
  };

  render() {
    if (!this.state.business || !this.state.company) return <Spin />;
    const { companyId, branchId, business } = this.state;

    return (
      <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
        {this.state.user &&
          checkAddPermission(this.state.user) &&
          this.state.business &&
          this.state.company && (
            <Tabs.TabPane
              tab={
                <span>
                  <Icon type="plus" />
                  Add Expense Entry
                </span>
              }
              key="1"
              closable={false}
            >
              <AddExpenseEntry
                company={this.state.company}
                business={business}
              />
            </Tabs.TabPane>
          )}
        {/* {this.state.company && this.state.business && (
          <Tabs.TabPane
            tab={
              <span>
                <Icon type="table" />
                Expense Entry Report
              </span>
            }
            key="2"
            closable={false}
          >
            <ExpenseEntryReport
              company={this.state.company}
              business={this.state.business}
              after={this.state.afterExpenseEntry}
              currentPage={this.state.currentPageExpenseEntry}
              onPageChange={this.onPageChangeExpenseEntry}
            />
          </Tabs.TabPane>
        )} */}
        {this.state.company && this.state.business && (
          <Tabs.TabPane
            tab={
              <span>
                <Icon type="table" />
                Expense Entry Report(Date Range)
              </span>
            }
            key="3"
            closable={false}
          >
            <ExpenseEntryReportDateRange
              company={this.state.company}
              business={business}
              companyId={companyId}
              branchId={branchId}
            />
          </Tabs.TabPane>
        )}
      </Tabs>
    );
  }
}

interface State {
  activeKey: string;
  afterExpenseEntry: string;
  currentPageExpenseEntry: number;
  company: CompanyNodeEdge | null;
  business: Bussiness | null;
  user?: UserNodeEdge | null;
  branchId?: string | null;
  companyId: string;
}
